export default "__VITE_ASSET__BqEBPS4H__"